import { render, staticRenderFns } from "./AuthorMedal.vue?vue&type=template&id=7c931de5"
import script from "./AuthorMedal.vue?vue&type=script&lang=js"
export * from "./AuthorMedal.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/youtube/yt-live-chat-author-medal-renderer.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports